import { podeFiscalizar } from '../../auth/permissoes'
import { useSessao } from '../../auth/contexto'
import { useDefinirObservado, useRepositoriosConhecidos } from '../../api/queries/repositorios'
import { Botao } from '../../components/Botao'
import { AvisoDeErro, Esqueleto } from '../../components/Estados'
import { dataHora } from '../../lib/datas'
import { TEXTOS } from '../../lib/glossario'

/**
 * Todos os repositórios que a coleta conhece, e o liga/desliga de cada um.
 *
 * A descoberta traz tudo o que o GitHub App alcança — inclusive repositório de teste e espelho de
 * acervo antigo. Por isso só o e-Cidade nasce na coleta (decisão do dono, 07/09/2026); o resto
 * nasce desligado. Desligar tira das contas sem apagar; é ato do fiscal.
 *
 * @returns a lista
 */
export function RepositoriosConhecidos() {
  const t = TEXTOS.repositorios.repositoriosTab
  const { usuario } = useSessao()
  const { data, isPending, isError, error } = useRepositoriosConhecidos()
  const definir = useDefinirObservado()
  const fiscal = podeFiscalizar(usuario)

  return (
    <section className="cartao p-5" aria-label={t.conhecidos}>
      <h2 className="text-base font-semibold text-slate-900">{t.conhecidos}</h2>
      <p className="mt-1 max-w-prose text-sm text-slate-500">{t.conhecidosAjuda}</p>
      <p className="mt-1 max-w-prose text-sm text-slate-500">{t.escopoPadrao}</p>
      {isPending && <Esqueleto linhas={3} className="mt-3" />}
      {isError && <AvisoDeErro erro={error} />}
      {definir.isError && <AvisoDeErro erro={definir.error} />}
      {data && (
        <ul className="mt-3 divide-y divide-slate-100">
          {data.map((r) => (
            <li key={r.id} className="flex flex-wrap items-center gap-3 py-2 text-sm">
              <div className="min-w-0 flex-1">
                <a
                  href={r.url}
                  target="_blank"
                  rel="noreferrer"
                  className="font-medium text-niteroi-700 underline underline-offset-2 hover:text-niteroi-900"
                >
                  {r.dono}/{r.nome}
                </a>
                <p className="text-xs text-slate-500">
                  {r.branchPadrao ?? '—'} · {r.commits} {r.commits === 1 ? 'commit' : 'commits'} · {dataHora(r.ultimoCommitEm)}
                  {r.arquivado && ` · ${t.arquivado}`}
                </p>
              </div>
              <span
                className={
                  r.observado
                    ? 'rounded-full bg-green-50 px-2 py-0.5 text-xs font-medium text-green-900 ring-1 ring-inset ring-green-200'
                    : 'rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-600 ring-1 ring-inset ring-slate-200'
                }
              >
                {r.observado ? t.observado : t.desligado}
              </span>
              {fiscal && (
                <Botao
                  aparencia="texto"
                  tamanho="pequeno"
                  disabled={definir.isPending}
                  onClick={() => definir.mutate({ id: r.id, observado: !r.observado })}
                >
                  {r.observado ? t.desligar : t.ligar}
                </Botao>
              )}
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
